module.exports = __webpack_public_path__ + "img/plus-icon.ed66e0ce.svg";